import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { FILTER_SITES } from "../../constants/filter-types";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import SettingSelectField from '../settingFields/SettingSelectField';
interface WizardDescriptionProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    itemId?: string;
}

export const WizardDescription: FC<WizardDescriptionProps> = ({ onBack = undefined, onNext = undefined }) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const [description ,setDescription] = useState<string>();
    const { translate } = useLocale();

    useEffect(() => {
        setSettingTypeId();
    }, [values.type])

    const setSettingTypeId = () => {
        const selectedOption = values.type;
        if (selectedOption === FILTER_SITES) {

            setDescription(translate.byKey(TranslationKeys.site));
            return setFieldValue('columnId', FILTER_SITES);
        }
        return setFieldValue('columnId', '');
    }

    const selectOptions = [{
        value: FILTER_SITES,
        label: translate.byKey(TranslationKeys.site)
    }];

    const handleBack = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (onBack) {
            onBack(e);
        }
    };

    const handleNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (onNext) {
            onNext({ ...e, itemName: description, filterItem: values })
        }
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-row">
            {values.id
                ? <SettingSelectField
                    accessor={'type'}
                    disabled={true}
                    displayName={translate.byKey(TranslationKeys.type)}
                    options={selectOptions}></SettingSelectField>
                : <SettingSelectField
                    accessor={'type'}
                    displayName={translate.byKey(TranslationKeys.type)}
                    options={selectOptions}></SettingSelectField>}
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={handleBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${!(values.type) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                    type='button'
                    id="wizardDescriptionNextBtn"
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>;
};
